import { render, staticRenderFns } from "./TextareaLabel.vue?vue&type=template&id=bf34e378"
import script from "./TextareaLabel.vue?vue&type=script&lang=js"
export * from "./TextareaLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports